import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Box, Card } from '@mui/material';
import { styleVariables } from '../constants';

const CardRootElement = styled(Card)`
    .card-action {
        min-width: 228px;
        width: 100%;
        border-radius: 8px;
        box-shadow:0px 0px 0px 1px rgba(0, 0, 0, 0.10) inset;
        & > div:active {
            background: #fff;
        }
        &:focus {
            & > div {
                box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1) inset;
                background: #fff !important;
            }
            svg {
                svg {
                    outline: none !important;
                }
            }
        }
    }
    .default-card-image {
        height: 205px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
        position: relative;
        img {
            height: 100% !important;
            -o-object-fit: contain;
            object-fit: contain;
            width: 100%;
        }
        .shimmer-card {
            position: absolute;
        }
    }
    .features-default-card-image {
        padding: 0;
        height: fit-content;
    }
    .card-heading {
        height: 52px;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: -o-ellipsis-lastline;
        @media (max-width: 1040px) {
            height: 44px;
        }
        @media (max-width: 767px) {
            height: 46px;
        }
    }
    .card-desc {
        height: 48px;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: -o-ellipsis-lastline;
    }
    .card-desc-fourlines {
        height: 105px;
        -webkit-line-clamp: 5;
        font-size: 14px;
    }
    button svg {
        outline: none !important;
    }
    .view-button{
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 19px;
        color:#000 !important;
        text-decoration:none;
        display: inline-flex;
        align-items: center;
        svg{
            width:20px;
            margin-right:8px;
        }
        .hover{
            display:none;
        }
        &:hover, &:active{
            text-decoration:none;
            .default{
                display:none;
            }
            .hover{
                display:inline-block;
            }
        }
    }
`;

const CardCarouselRootElement = styled(Box)`
    .card-details {
        padding-right: 16px;
    }
`;

const SlickCaroselRootElement = styled(Box)`
    position: relative;
    .prev-button,
    .next-button {
        background: url(${'/support/partners/images/slider-arrow.svg'}) center center no-repeat;
        color: ${styleVariables.primitivesColor.primary.black};
        border-radius: 50px;
        border: 1px solid #000;
        width: 28px;
        height: 28px;
        padding: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 28px !important;
        position: absolute;
        box-sizing: border-box;
        text-indent: -99999px;
        right: 0;
        top: -48px;
        background-size: 19px;
        overflow: hidden;
        &:focus,
        &:active {
            color: ${styleVariables.primitivesColor.primary.black};
            box-shadow: none;
            padding: 4px;
        }
        &[disabled] {
            opacity: 0.4;
        }
        @media (max-width: 767px) {
            background-size: 17px;
            top: -32px;
        }
    }
    .prev-button {
        right: 40px;
        transform: rotate(180deg);
    }
    .slick-loading .slick-list {
        background: #fff url('./ajax-loader.gif') center center no-repeat;
    }

    /* Icons */
    @font-face {
        font-family: 'slick';
        font-weight: normal;
        font-style: normal;
        src: url('./fonts/slick.eot');
        src:
            url('./fonts/slick.eot?#iefix') format('embedded-opentype'),
            url('./fonts/slick.woff') format('woff'),
            url('./fonts/slick.ttf') format('truetype'),
            url('./fonts/slick.svg#slick') format('svg');
    }
    /* Arrows */
    .slick-prev,
    .slick-next {
        font-size: 0;
        line-height: 0;
        position: absolute;
        top: 50%;
        display: block;
        width: 20px;
        height: 20px;
        padding: 0;
        -webkit-transform: translate(0, -50%);
        -ms-transform: translate(0, -50%);
        transform: translate(0, -50%);
        cursor: pointer;
        color: transparent;
        border: none;
        outline: none;
        background: transparent;
    }
    .slick-prev:hover,
    .slick-prev:focus,
    .slick-next:hover,
    .slick-next:focus {
        color: transparent;
        outline: none;
        background: transparent;
    }
    .slick-prev:hover:before,
    .slick-prev:focus:before,
    .slick-next:hover:before,
    .slick-next:focus:before {
        opacity: 1;
    }
    .slick-prev.slick-disabled:before,
    .slick-next.slick-disabled:before {
        opacity: 0.25;
    }
    .slick-prev:before,
    .slick-next:before {
        font-family: 'slick';
        font-size: 20px;
        line-height: 1;
        opacity: 0.75;
        color: ${styleVariables.primitivesColor.primary.white};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .slick-prev {
        left: -25px;
    }
    [dir='rtl'] .slick-prev {
        right: -25px;
        left: auto;
    }
    .slick-prev:before {
        content: '←';
    }
    [dir='rtl'] .slick-prev:before {
        content: '→';
    }

    .slick-next {
        right: -25px;
    }
    [dir='rtl'] .slick-next {
        right: auto;
        left: -25px;
    }
    .slick-next:before {
        content: '→';
    }
    [dir='rtl'] .slick-next:before {
        content: '←';
    }

    /* Dots */
    .slick-dotted.slick-slider {
        margin-bottom: 30px;
    }

    .slick-dots {
        position: absolute;
        bottom: -25px;
        display: block;
        width: 100%;
        padding: 0;
        margin: 0;
        list-style: none;
        text-align: center;
    }
    .slick-dots li {
        position: relative;
        display: inline-block;
        width: 20px;
        height: 20px;
        margin: 0 5px;
        padding: 0;
        cursor: pointer;
    }
    .slick-dots li button {
        font-size: 0;
        line-height: 0;
        display: block;
        width: 20px;
        height: 20px;
        padding: 5px;
        cursor: pointer;
        color: transparent;
        border: 0;
        outline: none;
        background: transparent;
    }
    .slick-dots li button:hover,
    .slick-dots li button:focus {
        outline: none;
    }
    .slick-dots li button:hover:before,
    .slick-dots li button:focus:before {
        opacity: 1;
    }
    .slick-dots li button:before {
        font-family: 'slick';
        font-size: 6px;
        line-height: 20px;
        position: absolute;
        top: 0;
        left: 0;
        width: 20px;
        height: 20px;
        content: '•';
        text-align: center;
        opacity: 0.25;
        color: ${styleVariables.primitivesColor.primary.black};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .slick-dots li.slick-active button:before {
        opacity: 0.75;
        color: ${styleVariables.primitivesColor.primary.black};
    }
    .slick-slider {
        position: relative;
        display: block;
        box-sizing: border-box;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-touch-callout: none;
        -khtml-user-select: none;
        -ms-touch-action: pan-y;
        touch-action: pan-y;
        -webkit-tap-highlight-color: transparent;
    }

    .slick-list {
        padding: 0 20% 0 0;
        position: relative;
        display: block;
        overflow: hidden;
        margin: 0;
    }
    .slick-list:focus {
        outline: none;
    }
    .slick-list.dragging {
        cursor: pointer;
        cursor: hand;
    }

    .slick-slider .slick-track,
    .slick-slider .slick-list {
        -webkit-transform: translate3d(0, 0, 0);
        -moz-transform: translate3d(0, 0, 0);
        -ms-transform: translate3d(0, 0, 0);
        -o-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }

    .slick-track {
        position: relative;
        top: 0;
        left: 0;
        display: block;
        margin: 0;
    }
    .slick-track:before,
    .slick-track:after {
        display: table;
        content: '';
    }
    .slick-track:after {
        clear: both;
    }
    .slick-loading .slick-track {
        visibility: hidden;
    }

    .slick-slide {
        display: none;
        float: left;
        height: 100%;
        min-height: 1px;
    }
    [dir='rtl'] .slick-slide {
        float: right;
    }
    .slick-slide img {
        display: block;
    }
    .slick-slide.slick-loading img {
        display: none;
    }
    .slick-slide.dragging img {
        pointer-events: none;
    }
    .slick-initialized .slick-slide {
        display: block;
    }
    .slick-loading .slick-slide {
        visibility: hidden;
    }
    .slick-vertical .slick-slide {
        display: block;

        height: auto;

        border: 1px solid transparent;
    }
    .slick-arrow.slick-hidden {
        display: none;
    }
    .slick-slide > div {
        margin: 0 8px;
    }
    .slick-list {
        margin: 0 -15px 0 -8px;
    }
    .prev-button {
    }
`;
export { CardRootElement, CardCarouselRootElement, SlickCaroselRootElement };
